import { View } from './View.js';

class RelatedItemsPaginationView extends View {
	_parentElement = document.querySelector('.pagination-content');

	//Add Handler to the prev and next btns
	addHandlerClick(handle) {
		this._parentElement = document.querySelector('.pagination-content');

		console.log('this._parentElement:', this._parentElement);
		this._parentElement.addEventListener('click', function (e) {
			const btn = e.target.closest('.pagination-btn');
			console.log(btn);
			const gotoPage = +btn.dataset.goto;
			console.log('gotoPage is :', gotoPage);
			handle(gotoPage);
		});
	}

	_generateMarkUp() {
		const NoOfPages = Math.ceil(
			this._pageData.items.length / this._pageData.itemsPerPage
		);
		const curPage = this._pageData.page;
		console.log('curPage:', curPage, 'NOOFPAGES:', NoOfPages);

		this._parentElement = document.querySelector('.pagination-content');

		if (NoOfPages === 1)
			return `
			<button class="pagination-btn-disabled relatedItems-btn-prev" disabled >السابق</button>
			<button class="pagination-btn-disabled relatedItems-btn-next" disabled >التالى</button>`;
		if (curPage === 1)
			return `
			<button class="pagination-btn-disabled relatedItems-btn-prev" disabled >السابق</button>
			<button class="pagination-btn relatedItems-btn-next" data-goto=${
				curPage + 1
			}>التالى</button>`;
		else if (curPage === NoOfPages)
			return `
				<button class="pagination-btn relatedItems-btn-prev" data-goto=${
					curPage - 1
				}>السابق</button>
				<button class="pagination-btn-disabled relatedItems-btn-next" disabled >التالى</button>`;
		else
			return `
			<button class="pagination-btn relatedItems-btn-prev" data-goto=${
				curPage - 1
			}>السابق</button>
			<button class="pagination-btn relatedItems-btn-next" data-goto=${
				curPage + 1
			}>التالى</button>`;
	}
}

export default new RelatedItemsPaginationView();
